module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"removeCustomField":"Remove field from {parentName}","clearCustomField":"Reset field to default state","manageAll":"Manage all custom fields"}}')
  delete Component.options._Ctor
}
